<p [ngClass]="values"></p>
